import { useEffect, useRef, useState } from 'react'
import { useTraitFilters } from '../api/filters'
import sortingIcon from 'bundle-text:../assets/icons/sorting.svg'
import { twMerge } from 'tailwind-merge'
import { useOnClickOutside } from '~/utils/hooks/useOnClickOutside'
import { useMarketplace } from '../context'

export function Sorting() {
    const [open, setOpen] = useState(false)
    const [selected, setSelected] = useState<string>(null)
    const { data } = useTraitFilters()
    const { state, setSort } = useMarketplace()
    const sortingOptions = data?.sorting_options || []

    const ref = useRef<HTMLDivElement>(null)

    useOnClickOutside(ref, () => setOpen(false))

    useEffect(() => {
        setSelected(state.sort)
    }, [state.sort])

    useEffect(() => {
        const timer = setTimeout(() => setSort(selected), 100)
        return () => clearTimeout(timer)
    }, [selected])

    return (
        <div
            ref={ref}
            className='relative flex flex-row items-center gap-2 bg-white/10 p-2 rounded cursor-pointer tracking-wide'
            onClick={() => setOpen((o) => !o)}
        >
            <span className='pointer-events-none' dangerouslySetInnerHTML={{ __html: sortingIcon }}></span>
            {open && (
                <div className='absolute right-0 top-full flex flex-col z-10 bg-black border border-white/20 rounded mt-2 p-2 min-w-max font-bold'>
                    {sortingOptions.map((option) => (
                        <div
                            key={option.value}
                            className={twMerge(
                                'whitespace-nowrap bg-black p-2 rounded mt-1 hover:bg-white/10',
                                selected === option.value && 'bg-white/20'
                            )}
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                setSelected(option.value)
                                setOpen(false)
                            }}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
